import React, { useState } from "react";
import AddressForm from "./AddressForm";

export default function AddressTab({
  addresses,
  onAdd,
  onUpdate,
  onRemove,
  onSetDefault,
}) {
  const [editingIndex, setEditingIndex] =
    useState(null);

  return (
    <div className="erp-section">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <div className="erp-section-title">
          Addresses
        </div>

        <button
          className="btn btn-sm btn-primary"
          onClick={() => setEditingIndex(-1)}
        >
          + Add Address
        </button>
      </div>

      {editingIndex !== null && (
        <AddressForm
          initialData={
            editingIndex >= 0
              ? addresses[editingIndex]
              : null
          }
          onCancel={() => setEditingIndex(null)}
          onSave={(data) => {
            if (editingIndex >= 0) {
              onUpdate(editingIndex, data);
            } else {
              onAdd(data);
            }
            setEditingIndex(null);
          }}
        />
      )}

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Type</th>
            <th>City</th>
            <th>State</th>
            <th>Pincode</th>
            <th>Default</th>
            <th width="140">Action</th>
          </tr>
        </thead>

        <tbody>
          {addresses.length === 0 && (
            <tr>
              <td
                colSpan={6}
                className="text-center text-muted"
              >
                No addresses added
              </td>
            </tr>
          )}

          {addresses.map((a, i) => (
            <tr key={i}>
              <td>{a.address_type}</td>
              <td>{a.city}</td>
              <td>{a.state}</td>
              <td>{a.pincode}</td>
              <td>{a.is_default ? "✔" : ""}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() =>
                    setEditingIndex(i)
                  }
                >
                  Edit
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemove(i)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
